import React from 'react';
import { Body, Modal } from '@icarros/ids-react';

import { useAdContext } from '../../../../../store/contexts/ad';

interface WarningOnBackModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
  closeEditPage(): void;
  title: string;
  body: string;
}

export function WarningOnBack({
  modalOpen,
  setModalOpen,
  closeEditPage,
  title,
  body
}: WarningOnBackModalProps): JSX.Element {
  const { setCurrentWarningMessage } = useAdContext();
  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <Body size="body_2" contrast="default" weight="regular" variant="base">
          {body}
        </Body>
      }
      title={title}
      mainButtonText="continuar"
      mainButtonMethod={() => {
        closeEditPage();
        setModalOpen(false);
        setCurrentWarningMessage(undefined);
      }}
      secondaryButtonText="voltar"
      secondaryButtonMethod={() => {
        setModalOpen(false);
      }}
    />
  );
}
